// Note: The first file of a module here, must also register the module

import "./cover-photo.component";
import "./create-event.component";
import "./event-user-card.component";
import "./event-info.component";
import "./event.helper";
import "./event-list.component";
import "./events.component";
import "./view-event.component";

import "./dates";
